module.exports = __webpack_public_path__ + "static/img/main_logo.d522f1ef.svg";